var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28691 11.3003L15.2217 3.28967C15.6042 2.90344 16.2248 2.90344 16.6073 3.28967L17.5329 4.22412C17.915 4.60994 17.9154 5.23483 17.5345 5.62147L11.2459 11.9998L17.5341 18.3785C17.9154 18.7652 17.9146 19.3901 17.5325 19.7759L16.6069 20.7103C16.2244 21.0966 15.6038 21.0966 15.2212 20.7103L7.28691 12.6993C6.90436 12.3131 6.90436 11.6865 7.28691 11.3003Z",
    fill: "#999999"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/ChevronLeft.317eac87e3488e9570ad1cda083269f0.svg";
export { ForwardRef as ReactComponent };